














































































































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import { RecompCycleProductSummary, RecompCycleProductAccountSummary } from '@/api/recomp';
import { Product } from '@/api/product';
import moment from 'moment';

@Component({
  computed: mapState(['fiId']),
})
export default class RecompCycleProductAccountSummaryCard extends Vue {
  @Prop() reloadId!: string;

  @Prop() recompCycles!: Cycle[];

  @Prop() productName!: string;

  @Prop() recompCycleProductAccountSummaries!:RecompCycleProductAccountSummary[];

  @Prop() recompCycleProductSummaries!:RecompCycleProductSummary[];

  fiId!: number;

  loading: boolean = true;

  headers: DataTableHeader[] = [];

  displayedRecompSummaries:RecompCycleProductAccountSummary[] = [];

  displayedAccountsImpacted:number = 0;

  displayedAmountDistributed:string = '0.00';

  selectedSummaryCycleIndex:number = 0;

	footerProps:any = {
	  'items-per-page-options': [10, 25, 100],
	};

	mounted() {
	  this.initializeView();
	}

  @Watch('allRecompCycleProductAccountSummaries')
	async initializeView() {
	  if (this.recompCycleProductSummaries.length > 0 && this.recompCycleProductAccountSummaries.length > 0) {
	    this.updateOverallSummaryView(0, null);
	  }
	}

  updateOverallSummaryView(selectedIndex:number, selectedCycleId:any) {
    this.loading = true;
    this.selectedSummaryCycleIndex = selectedIndex;
    let summariesToDisplay:RecompCycleProductAccountSummary[] = [];
    if (selectedCycleId === null) {
      // this shows all the rows of data across all cycles
      summariesToDisplay = this.recompCycleProductAccountSummaries;
    } else {
      summariesToDisplay = this.recompCycleProductAccountSummaries.filter((recompSummary:RecompCycleProductAccountSummary) => recompSummary.cycleId === selectedCycleId);
    }
    this.setHeadersForDataTable(summariesToDisplay, selectedCycleId);
    this.displayedRecompSummaries = summariesToDisplay;
    this.displayedAmountDistributed = this.recompCycleProductSummaries.filter((summary:RecompCycleProductSummary) => summary.cycleId === selectedCycleId)[0].totalRewardsAmount;
    this.displayedAccountsImpacted = this.recompCycleProductSummaries.filter((summary:RecompCycleProductSummary) => summary.cycleId === selectedCycleId)[0].accountCount;
    this.loading = false;
  }

  setHeadersForDataTable(summariesToDisplay:RecompCycleProductAccountSummary[], selectedCycleId:any) {
    this.headers = [];
    // these columns are always shown
    this.headers.push({ text: 'Name of primary accountholder', value: 'coreCustomerName' });
    this.headers.push({ text: 'Account Number', value: 'coreAccountNumber' });
    this.headers.push({ text: 'Old Level', value: 'oldRewardLevel' });
    this.headers.push({ text: 'New Level', value: 'newRewardLevel' });

    // these columns are visible depending on whether all values in the summary contents are null or contain values
    let nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldIsInterestQualified !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Is Interest Qualified', value: 'oldIsInterestQualified' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newIsInterestQualified !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Is Interest Qualified', value: 'newIsInterestQualified' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldInterest !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Interest', value: 'oldInterest' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newInterest !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Interest', value: 'newInterest' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.interestDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Interest Difference', value: 'interestDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldCombinedAtmFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Combined ATM Fee', value: 'oldCombinedAtmFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newCombinedAtmFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Combined ATM Fee', value: 'newCombinedAtmFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.combinedAtmFeeDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Combined ATM Fee Difference', value: 'combinedAtmFeeDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldAtmTerminalFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old ATM Terminal Fee', value: 'oldAtmTerminalFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newAtmTerminalFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New ATM Terminal Fee', value: 'newAtmTerminalFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.atmTerminalFeeDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'ATM Terminal Fee Difference', value: 'atmTerminalFeeDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldAtmForeignFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old ATM Foreign Fee', value: 'oldAtmForeignFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newAtmForeignFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New ATM Foreign Fee', value: 'newAtmForeignFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.atmForeignFeeDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'ATM Foreign Fee Difference', value: 'atmForeignFeeDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldCashBack !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Cash Back', value: 'oldCashBack' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newCashBack !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Cash Back', value: 'newCashBack' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.cashBackDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Cash Back Difference', value: 'cashBackDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldTunesRefunds !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Tunes Refund', value: 'oldTunesRefunds' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newTunesRefunds !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Tunes Refund', value: 'newTunesRefunds' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.tunesRefundsDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Tunes Refund Difference', value: 'tunesRefundsDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldNetServiceFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Net Service Fee', value: 'oldNetServiceFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newNetServiceFee !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Net Service Fee', value: 'newNetServiceFee' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.netServiceFeeDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Net Service Fee Difference', value: 'netServiceFeeDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldEatsReward !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Eats Reward', value: 'oldEatsReward' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newEatsReward !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Eats Reward', value: 'newEatsReward' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.eatsRewardDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Net Eats Reward Difference', value: 'eatsRewardDifference' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.oldStreamingReward !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Old Streaming Reward', value: 'oldStreamingReward' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.newStreamingReward !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'New Streaming Reward', value: 'newStreamingReward' });
    }
    nonNullData = summariesToDisplay.filter((summary:RecompCycleProductAccountSummary) => summary.streamingRewardDifference !== null);
    if (nonNullData.length > 0) {
      this.headers.push({ text: 'Net Streaming Reward Difference', value: 'streamingRewardDifference' });
    }
    if (selectedCycleId === null) {
      this.headers.push({ text: 'Qual End Date', value: 'qualificationsEndDate' });
    }
  }

  getCycleHeaderAllCyclesFriendlyDate(): string {
    const formattedStartDate = (moment(this.recompCycles[0].qualificationStartDate)).format('MM/DD');
    const formattedEndDate = (moment(this.recompCycles[this.recompCycles.length - 1].qualificationEndDate)).format('MM/DD');

    return `ALL CYCLES (${formattedStartDate}-${formattedEndDate})`;
  }

  getCycleHeaderFriendlyDate(cycle: Cycle): string {
    const reloadId = this.reloadId;
    const formattedStartDate = (moment(cycle.qualificationStartDate)).format('MM/DD');
    const formattedEndDate = (moment(cycle.qualificationEndDate)).format('MM/DD');

    return `${formattedStartDate}-${formattedEndDate}`;
  }

  /* eslint-disable class-methods-use-this */
  getFormattedMoney(amount:string):string {
    if (amount.startsWith('-')) {
      return `$(${amount.substring(1)})`;
    }
    return `$${amount}`;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
